import { cloneDeep } from 'lodash'
import { getData } from '@/components/schoolInstrument/component/mutual/component/screen/utils/utils.js'
import { axiosBase } from '@/api/api'
import axios from 'axios'
import { ElMessage } from 'element-plus'
import { apiImportapproval } from '@/port/clientSide/workbench'
import { isStandardClass, getClassInfo } from '@/api/global.js'
import * as XLSX from 'xlsx';
// import Vue from 'vue'
import { MY_CONSTANTS } from '@/util/constants'

// 获取当前树结构最大深度
export const getMaxDepth = (node) => {
  if (!node.children || node.children.length === 0) return 1
  return 1 + Math.max(...node.children.map(child => getMaxDepth(child)))
}

// 计算当前节点的rowspan
export const getLeafCount = (n) => {
  if (!n.children || n.children.length === 0) return 1;
  return n.children.reduce((sum, child) => sum + getLeafCount(child), 0);
};

// 获取随机数
export const getRandom = (min, max) => {
  const num = Math.floor(Math.random() * (max - min + 1)) + min
  return num
}

export const colInfo = { label: '选项', colItem: [], lineNum: 1 }

export const getSelectColInfo = (arr = [], option = {}) => {
  const data = cloneDeep(option)
  const id = getRandom(1000, 9999999)
  data.id = id
  if (!arr.length) return data
  const item = arr.findIndex(item => item.id === id)
  if (item !== -1) getSelectColInfo(arr)
  else return data
}

export const addColInfo = (li = []) => {
  const id = getRandom(1000, 9999999)
  const item = li.findIndex(item => item.id === id)
  if (item !== -1) addColInfo(li)
  const activeColInfo = {
    label: '选项1',
    colItem: [],
    lineNum: 1,
    id
  }
  const data = getSelectColInfo(activeColInfo.colItem, { styleInfo: {}, customize: [], customSize: 60 })
  activeColInfo.colItem.push(data)
  return activeColInfo
}

export const initAppCol = (val = 1)=>{
  const li = []
  for (let i = 0; i < val; i++) {
    const date = addColInfo(li)
    li.push(date)
  }
  return li
}

export const strToObject = (str) => {
  if (!str) return
  const query = typeof str === 'string' ? JSON.parse(str) : str
  return query
}

export const processedCols = (cols = []) => {
  const headers = []
  const process = (node, level = 0, parentIndex = '') => {
    if (!headers[level]) headers[level] = []
    const currentIndex = parentIndex + headers[level].length
    const targetField = node.targetField
    const item = {
      label: node.label,
      colspan: 1,
      rowspan: 1,
      dataIndex: currentIndex,
      value: node.value,
      looktype: node.looktype, // 查看类型
    }
    if (targetField) {
      item.key = `${targetField.title}_${targetField.type}_${targetField.name}`
    }
    if (node.children && node.children.length) {
      item.colspan = node.children.reduce((sum, child) => sum + (child.children ? child.children.length || 1 : 1), 0)
      item.rowspan = 1
      node.children.forEach(child => process(child, level + 1, currentIndex))
    } else item.rowspan = getMaxDepth({ children: cols }) - level - 1
    headers[level].push(item)
  }
  for (const ele of cols) {
    process(ele)
  }
  return headers
}

export const getLeafColumns = (columns) => {
  const leaves = []
  const getLeaves = (node) => {
    if ((node.children && !node.children.length) || !node.children) leaves.push(node)
    else node.children.forEach(child => getLeaves(child))
  }
  columns.forEach(child => getLeaves(child))
}

export const processedRows = (totalRows = []) => {
  const rows = [];
  // 获取数组的最大深度
  const maxDepth = getMaxDepth({ children: totalRows }) - 1
  // 处理行表头节点
  const processNode = (node, level = 0, rowIndex = 0, parentPath = []) => {
    // 确保当前行存在
    if (!rows[rowIndex]) {
      rows[rowIndex] = { headers: [], dataId: node.id, dataIndex: rowIndex, path: [], isAppenSelect: true };
    }
    const targetField = node.targetField
    const currentRow = rows[rowIndex];
    const colspan = maxDepth - level;
    const path = [...parentPath, node]
    currentRow.path = path
    // 添加当前节点到headers
    const row = {
      label: node.label,
      colspan: (!node.children || node.children.length === 0) && level !== maxDepth - 1 ? colspan : 1,
      rowspan: node.children && node.children.length ? getLeafCount(node) : 1,
    }
    const pathKey = path.map(node => {
      if (node.targetField) {
        return node.targetField.title
      } else {
        return ''
      }
    }).join('-');
    row.pathKey = pathKey
    row.looktype = node.looktype || 0
    if (targetField) {
      row.key = `${targetField.title}_${targetField.type}_${targetField.name}`
    }
    if (node.value) {
      row.value = node.value
    }
    currentRow.headers.push(row);
    // 处理子节点
    if (node.children && node.children.length) {
      let nextRowIndex = rowIndex;
      node.children.forEach(child => {
        // 对于每个子节点，从下一行开始处理
        nextRowIndex = processNode(child, level + 1, nextRowIndex, path);
      });
      return nextRowIndex;
    }
    
    return rowIndex + 1;
  };

  // 处理每个根节点
  let currentIndex = 0;
  totalRows.forEach(row => {
    currentIndex = processNode(row, 0, currentIndex);
  });
  
  return rows;
}


// 唯一的id生成
export const uuid = (a) => a ? (a ^ ((Math.random() * 16) >> (a / 4))).toString(16) : ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, uuid)

export const getDefaultTemp = async (opt = {}) => {
  let url = ''
  const { approvalId, isUpdate = false, unpivot } = opt
  const params = {
    approvalId,
    ispro: 1,
    update: isUpdate ? 1 : 'add'

  }
  if (unpivot) {
    params.unpivot = unpivot
  }
  const { code, data } = await axiosBase(params, '/api/getapprovaltemplate')
  if (code === 0) url = data
  return url
}

export const getFileName = (name) => {
  if (name) {
    const mps = name.split('/')
    const mp = mps[mps.length - 1]
    const strArr = mp.split('-')
    if (strArr.length > 1) {
      strArr.shift()
    }
    name = strArr.join('-')
  }
  return name
}

export const getBlobFromWorkbook = (wbData, fileName = '') => {
  return new Promise((resolve, reject) => {
    const formData = new FormData();
    const blob = new Blob([wbData], { type: 'application/vnd.ms-excel' });
    const file = new File([blob], `${fileName}.xls`, { type: 'application/vnd.ms-excel' });
    const token = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).accesstoken : ''
    formData.append('file', file);
    const config = { headers: { 'Content-Type': 'multipart/form-data' } }
    axios.post('/userfile/upload?accesstoken='+token, formData, config).then(res => {
      resolve(`/userfiles/${res.data}`)
    }).catch(err => {
      reject(err)
    })
  })
}

export const getParentNode = (data) => {
  const node = data.data
  const path = {
    label: node.label,
    id: node.id,
    value: node.fieldValue,
    targetField: node.targetField
  }
  if (node.level !== 1 && data.parent) {
    path.parent = getParentNode(data.parent)
  }
  return path
}

export const getNode = (data) => {
  const params = {}
  const targetField = data.targetField
  let value = data.value
  if (targetField) {
    const key = `${targetField.title}_${targetField.type}_${targetField.name}`
    params[key] = value
  }
  if (Array.isArray(data.value)) {
    value = data.value[0]
  }
  
  let par = {}
  if (data.parent) {
    par = getNode(data.parent)
  }
  
  return Object.assign({}, params, par)
}

export const getBlobFromURL = (url)=> {
  return new Promise((resolve) => {
    var xhr = new XMLHttpRequest();
      xhr.open('get', url, true);
      xhr.responseType = 'arraybuffer';
      xhr.onload = function() {
        if(xhr.status == 200) {
          resolve(xhr.response)
        }
      };
      xhr.send();
  })
}

export const testCol = [
  {
    label: "一级",
    key: 'level',
    children: [
      { label: "优秀", key: 'evaluate' },
      { label: "良好", key: 'evaluate' },
    ]
  },
  {
    label: "二级",
    key: 'level',
    children: [
      { label: "及格", key: 'evaluate'},
      { label: "需努力", key: 'evaluate' },
    ]
  }
]

export const testRows = [
  {
    label: "一年级一班",
    key: 'classify',
    children: [
      { label: "张三", key: 'student' },
      {
        label: "李四",
        key: 'student',
        children: [
          {
            label: "科目1",
            key: 'subject',
            children: [
              {
                label: "成绩1",
                key: 'score',
                children: [
                  { label: "语文1", key: 'chinese' },
                  { label: "数学2", key: 'math' },
                  { label: "音乐3", key: 'music'},
                ]
              },
              { label: "成绩2", key: 'score'},
              { label: "成绩3", key: 'score' },
            ]
          },
          {
            label: "科目2", 
            key: 'subject',
            children: []
          },
        ]
      },
    ]
  },
  {
    label: "一年级一班",
    key: 'classify',
    children: [
      { label: "张三", key: 'student' },
      { label: "李四", key: 'student'},
    ]
  },
]

export const testAppRow = [
  { label: "语文1", key: 'chinese' },
  { label: "数学2", key: 'math' },
  { label: "音乐3", key: 'music' },
  { label: "体育4", key: 'sport' },
  { label: "美术5", key: 'art' },
  { label: "英语6", key: 'english' },
  { label: "物理7", key: 'physics' },
  { label: "化学8", key: 'chemistry' },
  { label: "生物9", key: 'biology' },
  { label: "地理10", key: 'geography' },
  { label: "历史11", key: 'history' },
  { label: "政治12", key: 'politics' },
  { label: "其他13", key: 'other' },
  { label: "其他14", key: 'other' },
  { label: "其他15", key: 'other' },
  { label: "其他16", key: 'other' },
  { label: "其他17", key: 'other' },
  { label: "其他18", key: 'other' },
]


// 根据表头配置生成树结构
export const setThreeData = async (opt = {}) => {
  const { headerConfg, config = {}, isCustom = false } = opt
  let treeData = []
  if (headerConfg.screenLevel.levelType !== 'single' && config.optionsMenthods === 'custom' && !isCustom) return []
  if (headerConfg.screenLevel.levelType === 'single') {
    treeData = await getSingleData(opt)
  } else {
    treeData = await getTreeData(opt)
  }
  return treeData
}

const getSingleData = async (opt = {}) => {
  // 对象表字段
  const { headerConfg, customData, config, isCustom = false } = opt
  const { checkName, screenType, title, screenLevel } = headerConfg
  let type = '' // 当前显示字段的type
  let showFieldTitle = '' // 当前显示字段的title
  let option = []
  let looktype = 0
  if (headerConfg.activeName === 'dictionary') {
    // 字典
    const dictionary = cloneDeep(headerConfg.dictionary)
    dictionary.forEach(item => {
      if (Array.isArray(item.options) && item.options.length > 0) {
        option.push(...item.options) 
      }
    })
  } else if (headerConfg.activeName === 'custom') {
    // 自定义
    option = cloneDeep(headerConfg.customOption)
  }  else if (headerConfg.activeName === 'select') {
    if (config.optionsMenthods === 'custom' && !isCustom) option = []
    else {
      if (screenLevel && Array.isArray(screenLevel.levelList) && screenLevel.levelList[0]) {
        // 存在配置再走以下的逻辑
        let singleConfig = screenLevel.levelList[0]
        const { field, dataInfo, looktype: _looktype } = singleConfig
        if (field) {
          type = field.split('_')[2]
          showFieldTitle = dataInfo.datatype === 1 ? field.split('_')[0] : field.split('_')[1] // 当前表要使用的字段
        }
        if (_looktype) looktype = _looktype
        if (headerConfg.textFilterOpt === 'opt' && type === 'radio') {
          option = headerConfg.textDataSelShow
        } else {
          // 选项
          const list = await getData({ config: cloneDeep(singleConfig), customData })
          option = list.map(item => { return item[showFieldTitle] }).filter(item => { return item !== '' })
          if (type === 'relation-user') {
            const userList = []
            for (const item of option) {
              for (const user of item) {
                const index = userList.findIndex(u => u.userId === user.userId)
                if (index === -1) {
                  userList.push(user)
                }
              }
            }
            option = userList
          }
        }
      }
    }
  }
  const treeData = []
  option.forEach((item, index) => {
    const label = type === 'relation-user' ? (item.realname || item.name) : item
    const obj = {
      id: index + 1,
      label: label,
      children: [],
      value: item,
      looktype,
      targetField: {
        name: checkName,
        title,
        type: screenType
      }
    }
    const i = treeData.findIndex(iten => { return iten.label === label })
    if (i === -1) {
      treeData.push(obj)
    }
  })
  return treeData
}

// 创建树结构
const getTreeData = async (config, customData) => {
  let treeData = []
  const levelList = config.screenLevel.levelList
  const len = levelList.length
  const loadingLevel = 'all'
  let id = 0
  if (len > 0) {
    for (let index = 0; index < len; index++) {
      const config = levelList[index]
      const { field, fatherFilterList, dataInfo, looktype = 0 } = levelList[index]
      const title = dataInfo.datatype === 1 ? field.split('_')[0] : field.split('_')[1]
      const type = field.split('_')[2] // 当前表要使用的字段类型
      const data = await getData({ config: cloneDeep(config), loadingLevel, customData })
      data.forEach(item => {
        let label = type === 'relation-user' ? (item[title] && item[title].length > 0 ? item[title][0].realname : '') : item[title]
        if (Array.isArray(label)) label = label.join()
        const obj = {
          id: id++,
          label: label,
          data: item,
          fieldValue: item[title],
          fieldType: type,
          datatype: dataInfo.datatype,
          looktype,
          childrenIds: []
        }
        if (index === 0) {
          obj.level = index + 1
          obj.parentId = null
          // 第一级直接去重
          const treeIndex = treeData.findIndex(treeItem => { return label === treeItem.label })
          if (treeIndex === -1) {
            treeData.push(obj)
          }
        } else {
          // 获取过滤条件
          const filterObj = {}
          if (Array.isArray(fatherFilterList)) {
            fatherFilterList.forEach(iten => {
              let value = item[iten.currentField.title] || item[iten.currentField.name]
              if (iten.currentField.type === 'relation-user') {
                value = item[iten.currentField.title].length > 0 ? item[iten.currentField.title][0].realname : ''
              }
              filterObj[iten.fatherField] = value
            })
          }
          const i = treeData.findIndex(iter => {
            let flag = false
            if (iter.data && iter.level === index) {
              flag = filterData(filterObj, iter)
            }
            return flag
          })
          if (i !== -1) {
            obj.level = index + 1
            obj.parentId = treeData[i].id
            const treeIndex = treeData.findIndex(treeItem => {
              let flag = false
              // 避免重复的数据
              if (label === treeItem.label && obj.parentId === treeItem.parentId) {
                flag = true
              }
              return flag
            })
            // treeIndex == -1 说明该数据不存在 需要添加进去
            if (treeIndex === -1) {
              treeData[i].childrenIds.push(obj.id)
              if (obj.parentLable === undefined) obj.parentLable = treeData[i].parentLable ? [...treeData[i].parentLable] : []
              obj.parentLable.push(treeData[i].label) // 记录一下上级的值
              treeData.push(obj)
            }
          }
        }
      })
    }
  }
  // 去除不存在子级的节点
  const _treeData = cloneDeep(treeData)
  _treeData.forEach((item) => {
    // 最后一级的数据直接忽略
    if (item.level !== len && item.childrenIds.length === 0) {
      // 获取父级的index
      const parentIndex = treeData.findIndex(iten => { return item.parentId === iten.id })
      if (parentIndex !== -1 && treeData[parentIndex] && treeData[parentIndex].childrenIds) {
        // 获取在父级存贮的id的index
        const childrenIdsIndex = treeData[parentIndex].childrenIds.findIndex(id => { return id === item.id })
        // 删除在父级存贮的id、当父级存贮的id为空时，那这个父级就不显示
        treeData[parentIndex].childrenIds.splice(childrenIdsIndex, 1)
      }
    }
  })
  return createTree(treeData, config.filterList, levelList)
}

// 判断本条数据是否符合过滤条件
const filterData = (filterDataObj, treeData) => {
  let flag = true
  for (const key in filterDataObj) {
    // key是在父级的title ，value是本条数据的值
    const fatherTitle = treeData.datatype === 1 ? key.split('_')[0] : key.split('_')[1]
    const type = key.split('_')[2]
    const label = type === 'relation-user' ? (treeData.data[fatherTitle].length > 0 ? treeData.data[fatherTitle][0].realname : '') : treeData.data[fatherTitle]
    // 有一个条件对不上就是不满足
    if (label !== filterDataObj[key]) {
      flag = false
    }
  }
  return flag
}

// 创建树结构
const createTree = (list, filterList, levelList) => {
  const lookup = createLookup(list, filterList)
  const tree = []
  for (const item of list) {
    if (item.parentId !== null) {
      if (item.childrenIds.length > 0 || item.level === levelList.length) {
        lookup[item.parentId].children.push(lookup[item.id])
      }
    } else {
      if (item.childrenIds.length > 0 || item.level === levelList.length) {
        tree.push(lookup[item.id])
      }
    }
  }
  return tree
}

export const importData = async (tableData = [], config = {}) => {
  const { approvalId, isIncludesDetail, msg, isUpdate, isGetUrl, unpivot} = config
  if (tableData.length === 0) {
    ElMessage.warning('请选择数据')
    return
  }
  const path = await getDefaultTemp({ approvalId, isUpdate, unpivot })
  if (!path) {
    ElMessage.error('模板有误，请联系管理员！')
    return
  }
  let user = localStorage.getItem('user')
  let url = MY_CONSTANTS.$apiurl + '/' + path
  if (user) {
    user = JSON.parse(user)
    const accesstoken = user.accesstoken
    url += '?accesstoken=' + accesstoken
  }
  
  const blob = await getBlobFromURL(url)
  const data = new Uint8Array(blob);
  const workbook = XLSX.read(data, { type: 'array' });
  const sheetName = workbook.SheetNames[0]; // 获取第一个工作表
  const worksheet = workbook.Sheets[sheetName];
  const headersKey = {}
  const sheet = workbook.Sheets[sheetName]; // 获取表头
  const range = XLSX.utils.decode_range(sheet["!ref"]);
  for (let col = range.s.c; col <= range.e.c; col++) {
    for (let row = range.s.r; row <= range.e.r; row++) {
      const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
      const cell = sheet[cellAddress];
      if (cell) {
        const cellValue = cell.v;
        const name = cellValue.split('（必填')[0]
        headersKey[name] = Number(col) + 1
        console.log(`Cell ${cellAddress}:`, cellValue, col)
      } else {
        console.log(`Cell ${cellAddress}: (empty)`);
      }
    }
  }
  for (const idx in tableData) {
    const item = tableData[idx]
    // 从第二行开始插入
    let row = Number(idx) + 2
    if (isIncludesDetail) row += 1
    for (const ckey in item) {
      const val = item[ckey]
      // eslint-disable-next-line no-unused-vars
      const [title, type, name] = ckey.split('_')
      const col = headersKey[name]
      let newValue = { v: '', t: 's' }
      if (col) {
        if (['organization', 'roule'].includes(type)) {
          if (Array.isArray(val)) {
            newValue = { v: val.map(item => item.realname || item.name).join(','), t: 's' }
          } else {
            newValue = { v: val.realname || val.name, t: 's' }
          }
        } else if (['relation-user'].includes(type)) {
          if (Array.isArray(val)) {
            newValue = { v: val.map(item => `${item.realname || item.name}(${item.userId})`).join(','), t: 's' }
          } else if (typeof val === 'object') {
            newValue = { v: `${val.realname || val.name}(${val.userId})`, t: 's' }
          } else {
            newValue = { v: `${val.realname || val.name}(${val.userId})`, t: 's' }
          }
        } else if (['number'].includes(type)) {
          newValue = { v: val, t: 'n' }
        } else {
          if (typeof val === 'string') {
            newValue = { v: val, t: 's' }
          } else {
            newValue = { v: JSON.stringify(val), t: 's' }
          }
        }
        const cellRef = XLSX.utils.encode_cell({ r: row - 1, c: col - 1 });
        XLSX.utils.sheet_add_aoa(worksheet, [[newValue]], { origin: cellRef });
      }
    }
  }
  const newWorkbook = XLSX.utils.book_new();
  
  XLSX.utils.book_append_sheet(newWorkbook, worksheet, sheetName);
  const wbData = XLSX.write(newWorkbook, { bookType: 'xls', type: 'array' });
  const file = await getBlobFromWorkbook(wbData, sheetName)
  // 只需要生成的文件路径
  if (isGetUrl) {
    return file
  }
  const _params = {
    approvalId,
    isnotify: 0,
    ispro: 1,
    update: 0,
    file
  }
  const res = await apiImportapproval(_params)
  if (res.code === 0) {
    if (res.data.error > 0) {
      ElMessage.error(res.data.error + '条数据错误')
    } else {
      ElMessage.success(msg)
    }
  } else {
    ElMessage.error(res.msg)
  } 
}

// 传参进来设置了默认值 先弄联系人控件
export function defaultValuesForParameterTransmission(date, val = {}, isAddName = false) {
  const datas = cloneDeep(date)
  const obj = cloneDeep(val)
  for (const data of datas) {
    let key = data.title + '_' + data.type
    if (isAddName) {
      key += '_' + data.name
      if (data.type === 'relation-user' && !Array.isArray(obj[key])) {
        obj[key] = [obj[key]]
      }
    }
    
    if (data.type === 'relation-user' && data.bindfieldList && data.bindfieldList.length > 0 && obj[key].length > 0) {

      const li = [...new Set(data.bindfieldList)]
      for (const key in li) {
        // 这边写是因为  把原有的控件删了 这边的配置信息没删
        const ele = li[key]
        const [title] = ele.split('_')
        const isIn = Boolean(datas.find(item => (item.title === title)))
        if (!isIn) {
          const idx = data.bindfieldList.findIndex(item => item === ele)
          data.bindfieldList.splice(idx, 1)
        }
      }
      
      if (data.bindfieldList.length === 0) {
        continue
      }
      const userInfoKeys = {
        '姓名': 'realname',
        '登录名': 'username',
        '联系电话': 'realphone',
        '出生日期': 'birthday',
        '身份证': 'realidcard',
        '性别': 'sex'
      }
      const bindfieldList = data.bindfieldList
      let looktype = 1
      const userInfo = obj[key][0]
      
      bindfieldList.forEach(async item => {
        // 跟绑定的那个控件做个匹配
        const fliedIndex = date.findIndex(ruleItem => { return `${ruleItem.title}_${ruleItem.type}` === item})
        if (fliedIndex !== -1) {
          const flied = date[fliedIndex]
          // 两边不匹配就返回
          if (flied.bindfieldKey !== `${data.title}_${data.type}`) return false
          const bindfield = flied.bindfield // 要回填的字段
          // 联动出来的没有该字段 去请求一下
          let value = userInfo[bindfield] !== undefined ? userInfo[bindfield] : userInfo[userInfoKeys[bindfield]] 
          if (bindfield === '性别') {
            value = value ? '女' : '男'
          }
          value = getKey(value, 'name')
          if (value && value.search('userfiles') !== -1) {
            value = this.$url + value.replace('userfiles', 'conflies') 
          }
          const bindnewFiled = flied.bindnewFiled
          if (bindnewFiled && bindnewFiled[1] && isStandardClass(value, 'class')) {
            value = getClassInfo(value, bindnewFiled[1], looktype)
          }
          if (isAddName) {
            const [ title ] = item.split('_')
            const val = datas.find(f => f.title === title)
            obj[`${item}_${val.name}`] = value
          } else {
            obj[item] = value
          }
        }
      })
    }
  }
  return obj
}


// 列表转树结构
const createLookup = (list, filterList) => {
  const lookup = {}
  list.forEach(item => {
    let obj = { label: item.label, id: item.id, value: item.fieldValue, children: [] }
    if (filterList && filterList[item.level - 1]) {
      const field = filterList[item.level - 1]
      const [ title, name, type ] = field.split('_')
      obj.targetField = { name, title, type }
    }
    lookup[item.id] = obj
  })
  return lookup
}

// 根绝叶子节点转换树
export const splitTreeByLeavesCount = (tree, leavesPerTree) => {
  const leaves = [];
  const trees = [];

  // 递归遍历树结构，收集所有叶子节点
  function collectLeaves(node) {
    if (!node.children || node.children.length === 0) {
      leaves.push(node);
    } else {
      node.children.forEach(child => collectLeaves(child));
    }
  }

  // 递归构建树结构
  function buildTree(node, leafIds) {
    const newNode = { ...node };
    if (!node.children || node.children.length === 0) {
      if (leafIds.includes(node.id)) {
        return newNode;
      } else {
        return null;
      }
    } else {
      newNode.children = node.children
        .map(child => buildTree(child, leafIds))
        .filter(child => child !== null); // 过滤掉空的子节点
      return newNode.children.length > 0 ? newNode : null;
    }
  }

  // 收集所有叶子节点
  tree.forEach(rootNode => collectLeaves(rootNode));

  // 分割叶子节点并构建树
  for (let i = 0; i < leaves.length; i += leavesPerTree) {
    const leafSubset = leaves.slice(i, i + leavesPerTree).map(leaf => leaf.id);
    const newTree = tree.map(rootNode => buildTree(rootNode, leafSubset)).filter(Boolean);
    trees.push(newTree);
  }

  return trees;
}

// 文本组件
export const textTab = ['orders', 'status', 'text', 'textarea', 'radio', 'checkbox', 'richTextWid', 'relation-check', 'label']

export const isDefault = (type) => {
  return textTab.indexOf(type) !== -1
}
export const isBetween = (conditionValue) => {
  return conditionValue === 'between'
}
export const isDate = (type) => {
  return ['date', 'timeof', 'dates'].indexOf(type) !== -1
}
export const isNum = (type) => {
  return type === 'number'
}
export const isUser = (type) => {
  return ['relation-user', 'appuser'].indexOf(type) !== -1
}
export const isOrganize = (type) => {
  return ['organization'].indexOf(type) !== -1
}
export const isRole = (type) => {
  return ['roule'].indexOf(type) !== -1
}

export const isNewRelRadio = (type) => {
  return ['new-rel-radio'].indexOf(type) !== -1
}

export const getKey = (item, key = 'name') => {
  if(!item) return item
  const isStr = typeof item === 'string'
  if (isStr) return item
  else if (Array.isArray(item)) return item.map(f => f[key]).join(',')
  else return item[key]
}